interface NumbersWordListType {
	[key: number]: string;
}

const numbersWordList: NumbersWordListType = {
	1: "یک",
	2: "دو",
	3: "سه",
	4: "چهار",
	5: "پنج",
	6: "شش",
	7: "هفت",
	8: "هشت",
	9: "نه",
	10: "ده",
	11: "یازده",
	12: "دوازده",
	13: "سیزده",
	14: "چهارده",
	15: "پانزده",
	16: "شانزده",
	17: "هفده",
	18: "هجده",
	19: "نوزده",
	20: "بیست",
	30: "سی",
	40: "چهل",
	50: "پنجاه",
	60: "شصت",
	70: "هفتاد",
	80: "هشتاد",
	90: "نود",
	100: "صد",
	200: "دویست",
	300: "سیصد",
	400: "چهار صد",
	500: "پانصد",
	600: "شش صد",
	700: "هفت صد",
	800: "هشت صد",
	900: "نه صد",
	1000: "هزار",
	1000000: "میلیون",
	1000000000: "میلیارد",
	1000000000000: "تریلیون",
	1000000000000000: "کوآدریلیون",
};

export default numbersWordList;
